// ** React Imports
import { useEffect } from 'react'

// ** Next Import
import { useRouter } from 'next/router'

// ** Hooks Import
import { useAuth } from 'src/hooks/useAuth'
import authConfig from 'src/configs/auth'
import { authStorage } from 'src/utils/authStorage'

const AuthGuard = props => {
  const { children, fallback } = props

  const auth = useAuth()

  const router = useRouter()

  const storedToken = authStorage.getStoredToken(authConfig.storageTokenKeyName)
  const storedUserData = authStorage.getStoredUser('userData')

  // const storedToken = AuthStorage.getItem(authConfig.storageTokenKeyName)
  // const storedUserData = AuthStorage.getItem('userData')

  useEffect(
    () => {
      if (!router.isReady) {
        return
      }
      if (auth.user === null && storedUserData === null && storedToken === null && authStorage.isUserLoggedInStatus === false) {
      
        if (router.asPath !== '/') {
          router.replace({
            pathname: '/login',
            query: { returnUrl: router.asPath }
          })
        } else {
          router.replace('/login')
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [router.route]
  )
  if (auth.loading) {
    return fallback
  }

  return <>{children}</>
}

export default AuthGuard
